// Small CSV utility for admin exports.
// Converts an array of objects + ordered header list into a CSV string
// and triggers a browser download.

export function toCSV<T extends Record<string, any>>(
  rows: T[],
  headers: (keyof T)[],
): string {
  const escape = (val: any): string => {
    if (val === null || val === undefined) return ''
    const s = Array.isArray(val) ? val.join('; ') : String(val)
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`
    return s
  }
  const headerLine = headers.map((h) => escape(h as string)).join(',')
  const lines = rows.map((row) => headers.map((h) => escape(row[h])).join(','))
  return [headerLine, ...lines].join('\n')
}

export function downloadCSV(filename: string, csv: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
